import Cookies from "js-cookie";
import { Helpers } from "./Helpers";

export const WishList = (function () {
    "use strict";

    let favorites, is_favorites_page;

    function init() {
        is_favorites_page = $(".favorites-list").length > 0;
        favorites = Cookies.get("pool-breeze-favorites") ? JSON.parse(Cookies.get("pool-breeze-favorites")) : [];
        setQueryVars();
        setFavoritedBtns();
        printSetup();
    }

    function setQueryVars() {
        if (is_favorites_page) {
            let url = window.location.href;
            let params = Helpers.getUrlParams(url);
            if (
                favorites.length > 0 &&
                (!params || !params.favorites || params.favorites !== JSON.stringify(favorites))
            ) {
                if (url.indexOf("?") > -1) {
                    url += "&favorites=" + JSON.stringify(favorites);
                } else {
                    url += "?favorites=" + JSON.stringify(favorites);
                }
                window.location.href = url;
            }
        }
    }

    function setFavoritedBtns() {
        let $btnAdd = $(".btn.add-to-favorites");
        $btnAdd.each(function () {
            let pid = $(this).data("pid");
            if (favorites.indexOf(pid) > -1) {
                toggleFavoriteBtn($(this));
            }
        });
        addToFavorites();
        removeFromFavorites();
    }

    function addToFavorites() {
        let $btnAdd = $(".btn.add-to-favorites");
        $btnAdd.off().on("click", function (e) {
            e.preventDefault();
            let pid;
            pid = $(this).data("pid");
            favorites = favorites.filter((val) => val !== pid);
            favorites.push(pid);
            Cookies.set("pool-breeze-favorites", JSON.stringify(favorites));
            toggleFavoriteBtn($(this));
        });
    }

    function removeFromFavorites() {
        let $btnRemove = $(".btn.remove-from-favorites");
        $btnRemove.off().on("click", function (e) {
            e.preventDefault();
            let pid;
            pid = $(this).data("pid");
            favorites = favorites.filter((val) => val !== pid);
            Cookies.set("pool-breeze-favorites", JSON.stringify(favorites));
            toggleFavoriteBtn($(this));
            if (is_favorites_page) {
                window.location.href = "//" + window.location.host + window.location.pathname;
            }
        });
    }

    function toggleFavoriteBtn($btn) {
				let addLabel = $btn.attr('data-add-label') ? $btn.attr('data-add-label') : 'Add to Favorites List';
				let removeLabel = $btn.attr('data-remove-label') ? $btn.attr('data-remove-label') : 'Remove from Favorites';

        if ($btn.hasClass("remove-from-favorites")) {
            $btn.removeClass("remove-from-favorites");
            $btn.addClass("add-to-favorites").html(addLabel);
            addToFavorites();
        } else {
						$btn.removeClass("add-to-favorites");
						$btn.addClass("remove-from-favorites").html(removeLabel);
            removeFromFavorites();
        }
    }

    function printSetup() {
        if (is_favorites_page) {
            let $header = $(".site-header"),
                $footer = $(".site-footer"),
                $banner = $(".pxblock--banner"),
                $btnPrint = $(".favorites-list .btn--print");

            $btnPrint.click(function (e) {
                e.preventDefault();
                window.print();
            });

            $header.addClass("no-print");
            $footer.addClass("no-print");
            $banner.addClass("no-print");
            $btnPrint.addClass("no-print");
        }
    }

    return {
        init: init,
    };
})();
